import React from 'react'
import { connect } from 'react-redux'
import { reduxForm, Field } from 'redux-form'
import PropTypes from 'prop-types'

import {
  formContainer,
  titleContainer,
  secondaryTitle,
  buttonContainer
} from './styles/LoginForm.style'

import { Button } from '../shared/styles/Button.style'
import Input from '../shared/Input'

import * as validators from '../../utils/validators'

const ForgoteMyPasswordForm = ({
  handleSubmit,
  onSubmit,
  isSubmitting,
  translation,
  lang
}) => {
  const required = lang === 'pt-BR' ? validators.requiredPT : validators.requiredES
  const emailOrFractalId = lang === 'pt-BR' ? validators.requiredPT : validators.requiredES

  return (
    <form className={formContainer} onSubmit={handleSubmit(onSubmit)}>
      <header className={titleContainer}>
        <h2 className={secondaryTitle}>{translation('resetPassword')['resetPasswordTitle']}</h2>
      </header>

      <div>
        <Field
          name='login'
          placeholder={translation('resetPassword')['fractalIdPlaceholder']}
          type='text'
          block
          validate={[required, emailOrFractalId]}
          component={Input}
        />
      </div>

      <div className={buttonContainer}>
        <Button
          type='submit'
          disabled={isSubmitting}
        >
          {translation('resetPassword')['sendButton']}
        </Button>
      </div>
    </form>
  )
}

ForgoteMyPasswordForm.propTypes = {
  onSubmit: PropTypes.func.isRequired,
  handleSubmit: PropTypes.func.isRequired,
  isSubmitting: PropTypes.bool.isRequired,
  translation: PropTypes.bool.isRequired,
  lang: PropTypes.string
}

const mapStateToProps = ({ passwordRecovery }) => ({
  isSubmitting: passwordRecovery.isSubmitting
})

const mappedConnect = connect(mapStateToProps)
const mappedReduxForm = reduxForm({
  form: 'forgotMyPassowrd'
})

export default mappedConnect(mappedReduxForm(ForgoteMyPasswordForm))
